export const WA_LIST_MESSAGE_MAX_SECTIONS = 10
export const WA_LIST_MESSAGE_MAX_OPTIONS = 10

export const WA_LIST_MESSAGE_MAX_HEADER_LENGTH = 60
export const WA_LIST_MESSAGE_MAX_BODY_LENGTH = 1024
export const WA_LIST_MESSAGE_MAX_FOOTER_LENGTH = 60
export const WA_LIST_MESSAGE_MAX_BUTTON_LENGTH = 20
export const WA_LIST_MESSAGE_MAX_DESCRIPTION_LENGTH = 72
